import { Dispatch, SetStateAction, useEffect, useState } from "react";
import MultipleSelect from "../../../../components/MultipleSelect/MultipleSelect";
import { ISO639Lang } from "../../../../constans/languagesList";
import {
  PromocodesFilters,
  PromocodesParamsAvailable,
  PromocodeType,
} from "../../../../types/Promocodes";
import { getTranslation } from "../../../../utils/getTranslation";
import s from "./PromocodesFilters.module.css";

type SelectType = { value: string; lable: string; disabled?: boolean };

type FiltersData = {
  language?: SelectType[];
  mainSpecialization?: SelectType[];
  level?: SelectType[];
  type?: SelectType[];
};

type FlexPassFiltersProps = {
  setFilters: Dispatch<SetStateAction<PromocodesFilters>>;
  paramsAvailable: PromocodesParamsAvailable | undefined;
  filters: PromocodesFilters;
};

const PromocodesFiltersSection = ({
  setFilters,
  paramsAvailable,
  filters,
}: FlexPassFiltersProps) => {
  const [filtersData, setFiltersData] = useState<FiltersData>({});

  useEffect(() => {
    if (!paramsAvailable) return;

    const mainSpecData = paramsAvailable.mainSpecializations.map((item) => ({
      lable: getTranslation(item.value.labels, "en"),
      value: item.value._id,
    }));
    const levelsData = paramsAvailable.levels.map((item) => ({
      lable: getTranslation(item.value.title, "en"),
      value: item.value._id,
    }));
    const langsData = paramsAvailable.languages.map((item) => ({
      lable: ISO639Lang[item.value],
      value: item.value,
    }));

    const typeData = [
      {
        value: PromocodeType.SELECTION,
        lable: "Selection",
      },
      {
        value: PromocodeType.SUBSCRIBTION,
        lable: "FlexPass",
      },
    ];
    setFiltersData({
      language: langsData,
      level: levelsData,
      mainSpecialization: mainSpecData,
      type: typeData,
    });
  }, [paramsAvailable]);

  const activeStatusSelectConverter = {
    active: true,
    notActive: false,
    all: undefined,
  };

  return (
    <div className={s.container}>
      <MultipleSelect
        data={filtersData.mainSpecialization ?? []}
        multiplie={true}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            mainSpecialization: value.length ? (value as string[]) : undefined,
          }));
        }}
        value={filters.mainSpecialization ?? []}
        chip
        checkBox
        lable="Specializations"
        width="calc(25% - 20px)"
      />
      <MultipleSelect
        data={filtersData.level ?? []}
        multiplie={true}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            level: value.length ? (value as string[]) : undefined,
          }));
        }}
        value={filters.level ?? []}
        chip
        checkBox
        lable="Levels"
        width="calc(25% - 20px)"
      />
      <MultipleSelect
        data={filtersData.language ?? []}
        multiplie={true}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            language: value.length ? (value as string[]) : undefined,
          }));
        }}
        value={filters.language ?? []}
        chip
        checkBox
        lable="Language"
        width="calc(25% - 20px)"
      />

      <MultipleSelect
        data={filtersData.type ?? []}
        multiplie={false}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            type: value as PromocodeType,
          }));
        }}
        value={filters.type ?? ""}
        lable="Type"
        width="calc(25% - 20px)"
        disableSortData
      />
    </div>
  );
};

export default PromocodesFiltersSection;
